export default __webpack_public_path__ + "static/pict4Placeholder-80f71e9fa31313af03906f89cadb9a24.png";